var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waiting-popup p-1 bg-white dark-bg-gray-700 dark-text-white"},[_c('div',[_vm._v(" Ваш номер в очереди: "+_vm._s(_vm.numberInQueue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }